module.exports = __webpack_public_path__ + "img/scheme_lg.3008834.webp";